import TextInput from "../TextInput";
import Label from "../Label";
import SearchIcon from "/public/images/icons/search.svg?react";
import IncidentIcon from "/public/images/icons/incidentsIcon.svg?react";
import ManualActivityIcon from "/public/images/icons/manualActivityIcon.svg?react";
import { useState, useEffect, useRef } from "react";
import Button from "../Button";
import PropTypes from "prop-types";
import DatePicker from "../DatePicker";

export default function ActivitySearch({
  searchCriteria,
  setSearchCriteria,
  setSearchOverlayVisible,
  activityTypes,
  setCurrentPage,
}) {
  const [tempSearch, setTempSearch] = useState(searchCriteria.search);
  const [tempActivities, setTempActivities] = useState(searchCriteria.activities);
  const [tempDateFrom, setTempDateFrom] = useState(searchCriteria.dateFrom);
  const [tempDateTo, setTempDateTo] = useState(searchCriteria.dateTo);
  const [tempIncident, setTempIncident] = useState(searchCriteria.previousIncident === "unset" ? 0 : searchCriteria.previousIncident);
  const [manualActivityFilter, setManualActivityFilter] = useState(searchCriteria.manualActivity === "unset" ? 0 : searchCriteria.manualActivity);
  const prevTempSearch = useRef(searchCriteria.search);
  const prevTempActivities = useRef(searchCriteria.activities);
  const prevIncident = useRef(searchCriteria.previousIncident);
  const prevDateFrom = useRef(searchCriteria.dateFrom);
  const prevDateTo = useRef(searchCriteria.dateTo);

  const handleSearchVenue = () => {
    setSearchCriteria({
      activities: tempActivities,
      search: tempSearch,
      previousIncident: tempActivities.length === 0 && manualActivityFilter === 0 && tempIncident === 0 ? "unset" : tempIncident,
      manualActivity: tempActivities.length === 0 && tempIncident === 0 && manualActivityFilter === 0 ? "unset" : manualActivityFilter,
      dateFrom: tempDateFrom,
      dateTo: tempDateTo,
    });

    setCurrentPage(0);
    setSearchOverlayVisible(false);
  };
  console.log(tempActivities, "tempActivities");
  console.log(searchCriteria, "activities");

  const handleActivityToggle = (id) => {
    setTempActivities((prevActivities = []) => {
      if (prevActivities.some((activity) => activity.BaseActivityId === id)) {
        // Remove the object with the matching BaseActivityId
        return prevActivities.filter((activity) => activity.BaseActivityId !== id);
      } else {
        // Add the new object to the array
        return [...prevActivities, { BaseActivityId: id }];
      }
    });    
  };

  const handleManualActivityToggle = () => {
    setManualActivityFilter((prev) => (prev === true ? 0 : true));
  };

  const handleIncidentToggle = () => {
    setTempIncident((prev) => (prev === true ? 0 : true));
  };

  useEffect(() => {
    prevTempSearch.current = tempSearch;
    prevTempActivities.current = tempActivities;
    prevIncident.current = tempIncident;
    prevDateFrom.current = tempDateFrom;
    prevDateTo.current = tempDateTo;
  }, [tempSearch, tempActivities, tempIncident, manualActivityFilter, tempDateFrom, tempDateTo]);

  const handleDateFromChange = (e) => {
    setTempDateFrom(e.target.value);
  };
  
  const handleDateToChange = (e) => {
    setTempDateTo(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchCriteria({
      search: "",
      activities: [],
      previousIncident: "unset",
      manualActivity: "unset",
      dateFrom: "unset",
      dateTo: "unset",
    });

    setTempActivities([]);
    setTempDateFrom("");
    setTempDateTo("");
    setTempIncident(0);
    setManualActivityFilter(0);
    setTempSearch("");

    // Clear text input and date pickers by resetting their value
    const searchInput = document.querySelector("input[name='search']");
    if (searchInput) searchInput.value = "";

    const dateFromInput = document.querySelector("input[name='dateFrom']");
    if (dateFromInput) dateFromInput.value = "";

    const dateToInput = document.querySelector("input[name='dateTo']");
    if (dateToInput) dateToInput.value = "";

    setSearchOverlayVisible(false);
  }

  return (
    <div className="absolute top-0 left-0 flex flex-col w-full h-full bg-white px-6 py-8">
      <div className="relative w-full mb-[13px]">
        <TextInput
          name="search"
          type="text"
          label="Search by Venue"
          className="w-full [&>.relative>input]:pr-[42px] [&>.label]:p-0 [&>.label]:pb-1"
          autoComplete="off"
          onChange={(e) => setTempSearch(e.target.value)}
          defaultValue={tempSearch}
        />
        <SearchIcon className="absolute w-6 h-6 stroke-black right-[14px] bottom-[14px]" />
      </div>
      <div className="w-full">
        <div className="label p-0">
          <span className="text-sportsBlack font-medium text-base mb-4">Filters</span>
        </div>
        <div className="flex gap-x-3 gap-y-4 flex-row flex-wrap mb-5">
          {activityTypes.map((activity) => (
            <Label
              key={activity.BaseActivityId}
              className="!gap-1 cursor-pointer"
              onClick={() => handleActivityToggle(activity.BaseActivityId)} // Correctly toggle the activity name
              isActive={tempActivities?.some((tempActivity) => tempActivity.BaseActivityId === activity.BaseActivityId ? true : false) || false}
            >
              <img
                className="w-6 h-6"
                src={activity.BaseActivityIcon}
                alt={activity.BaseActivityName}
                width={24}
                height={24}
              />
              <span className="capitalize font-poppins leading-[15px]">{activity.BaseActivityName}</span>
            </Label>
          ))}

          <Label
            className="!gap-1 cursor-pointer"
            onClick={handleManualActivityToggle}
            isActive={manualActivityFilter === true ? true : false}
          >
            <ManualActivityIcon className="w-[20px] h-[20px]" />
            <span className="capitalize font-poppins leading-[15px]">manual activity</span>
          </Label>

          <Label
            className="!gap-1 cursor-pointer"
            onClick={handleIncidentToggle}
            isActive={tempIncident}
          >
            <IncidentIcon className="w-[20px] h-[20px]" />
            <span className="capitalize font-poppins leading-[15px]">with incidents</span>
          </Label>
        </div>
        <div className="flex w-full flex-col gap-5">
          <DatePicker
            name="dateFrom"
            label="Date From"
            defaultValue={tempDateFrom}
            onChange={handleDateFromChange}
          />

          <DatePicker
            name="dateTo"
            label="Date To"
            defaultValue={tempDateTo}
            onChange={handleDateToChange}
          />
        </div>
        
        <div className="mt-8 flex flex-col gap-2">
          <Button className="w-full" onClick={handleSearchVenue}>
            Update Search
          </Button>
          <Button variant="quaternary" className="w-full" onClick={handleClearSearch}>
            Clear Search
          </Button>
        </div>
      </div>
    </div>
  );
}

ActivitySearch.propTypes = {
  searchCriteria: PropTypes.shape({
    activities: PropTypes.array,
    search: PropTypes.string,
    previousIncident: PropTypes.any,
    manualActivity: PropTypes.any,
    dateFrom: PropTypes.any,
    dateTo: PropTypes.any,
  }).isRequired,
  setSearchCriteria: PropTypes.func.isRequired,
  setSearchOverlayVisible: PropTypes.func.isRequired,
};